module.exports = __webpack_public_path__ + "img/training_program_3.36a1e9f4.jpg";